/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagCategory
 */
export interface TagCategory {
    /**
     * 
     * @type {number}
     * @memberof TagCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TagCategory
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TagCategory
     */
    settings: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof TagCategory
     */
    clientId: number;
}

export function TagCategoryFromJSON(json: any): TagCategory {
    return TagCategoryFromJSONTyped(json, false);
}

export function TagCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'settings': json['settings'],
        'clientId': json['client_id'],
    };
}

export function TagCategoryToJSON(value?: TagCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'settings': value.settings,
        'client_id': value.clientId,
    };
}


